export default function unsubscriber([...subscriptions] = []) {
  function unsubscribe() {
    subscriptions.forEach((unsub) => unsub());
  }

  unsubscribe.add = (unsub) => subscriptions.push(unsub);

  return unsubscribe;
}
